import React, { useEffect, useMemo, useState } from 'react';
import { Layout, Justify, Segment } from 'tea-component';
import {
  FilterFixed,
  useFilterDataHook,
} from '@/pages/opinion/components/FilterCommon';
import { connect, useDispatch } from 'umi';
import CardLoading from '@/pages/opinion/components/CardLoading';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import ChartsBox from '../components/ChartsBox';
import '@/pages/opinion/assets/scss/pages/stats/keyword.scss';
import TranslateSelect from '@/pages/opinion/components/SelectComponents/TranslateSelect';
import { languageSelectOptions } from '@/pages/opinion/components/FilterBoxCommon/constant';
import { useInitBuriedPointInfo } from '@/pages/opinion/operationLog/buriedPoint';
import StatsKeywordPoint from '@op/operationLog/pages/statsKeyword';
import BubbleCommon, {
  statsKeywordHeaderText,
  statsKeywordNegativeText,
  statsKeywordPositiveText,
} from '@/pages/opinion/components/BubbleCommon';
import ContentBody from '@/pages/opinion/components/ContentBody';
import { PAGE_NAME } from '@op/constants/page';
import DetailPageTable, { ChannelType } from '@op/components/DetailPageTable';
import _ from 'lodash-es';
const { Content } = Layout;

function Keyword({
  gameInfo,
  keywordTimeline,
  keywordTimelineLoading,
  wholeGameInfo,
}: any) {
  useInitBuriedPointInfo({ buriedPoint: StatsKeywordPoint });
  const {
    loading,
    filter,
    changeFilter,
    filterOptions,
    scrollBody,
    topicList,
    changeTopicList,
  } = useFilterDataHook({
    gameInfo,
    pageName: 'Stats_Keyword',
  });
  const [channelType, setChannelType] = useState<ChannelType>('social');
  const { formatMessage, formatOptionsMessage } = useLanguage();
  const dispatch = useDispatch();
  const [sentimentType, setSentimentType] = useState<
    'total' | 'negative' | 'positive' | 'hashtag' | 'emerging'
  >('total');
  const [lang, setLang] = useState('origin');

  useEffect(() => {
    if (!gameInfo || !filter) return;
    const payload = {
      ...filter,
      ...gameInfo,
      statistics_field: 'keyword',
      version_time: '1',
    };
    if (sentimentType) {
      if (['negative', 'positive', 'total'].includes(sentimentType)) {
        payload.sentiment_type = sentimentType;
      } else {
        payload.keyword_kind = [sentimentType];
      }
    }
    dispatch({
      type: 'opinionPerformance/getOverviewKeywordTimeline',
      payload,
    });
  }, [gameInfo, filter, sentimentType]);

  const keywordTimeLineMemo = useMemo(() => {
    const obj: any = {}; 
    _.forEach(keywordTimeline, (element: any[], key: string | number) => {
      if (Array.isArray(element)) {
        obj[key] = element.filter((item) =>
          typeof item === 'object' ? item.name !== 'Others' : true,
        );
      } else {
        obj[key] = element;
      }
    });
    return obj;
  }, [keywordTimeline]);

  // console.log(keywordTimeline, 'keywordTimeline');

  return (
    <Content className="dbo-stats-keyword dbo-stats" ref={scrollBody}>
      <ContentBody
        pageName={PAGE_NAME.KEYWORD}
        contentHeard={
          <Content.Header
            title={formatMessage({ id: PAGE_NAME.KEYWORD })}
            subtitle={
              <div className="header-des">
                <BubbleCommon tipsMap={statsKeywordHeaderText}>
                  {formatMessage({ id: 'Only original keywords are counted' })}
                </BubbleCommon>
              </div>
            }
          />
        }
      >
        <FilterFixed
          filter={filterOptions}
          confirm={(value: any) => {
            changeFilter({ ...value, ...gameInfo, exclude_hashtag: true });
          }}
          backCondOriginData={(value) => {
            changeTopicList({ topic_trans: value.topic_trans, key_topic: {} });
          }}
          scrollBody={scrollBody}
        ></FilterFixed>
        <Justify
          className="dbo-stats-sgement-justify"
          left={
            <>
              <Segment
                className="segment-light"
                value={sentimentType}
                onChange={(value) => setSentimentType(value as any)}
                options={[
                  { text: formatMessage({ id: 'Total-2' }), value: 'total' },
                  {
                    text: (
                      <BubbleCommon
                        placement="top"
                        tipsMap={statsKeywordPositiveText}
                        showIcon={false}
                      >
                        {formatMessage({ id: 'Positive' })}
                      </BubbleCommon>
                    ),
                    value: 'positive',
                  },
                  {
                    text: (
                      <BubbleCommon
                        placement="top"
                        tipsMap={statsKeywordNegativeText}
                        showIcon={false}
                      >
                        {formatMessage({ id: 'Negative' })}
                      </BubbleCommon>
                    ),
                    value: 'negative',
                  },
                  {
                    text: formatMessage({ id: 'Emerging' }),
                    value: 'emerging',
                  },
                  { text: formatMessage({ id: 'Hot' }), value: 'hashtag' },
                ]}
              />
              <TranslateSelect
                lang={lang}
                isSingle
                langOptions={formatOptionsMessage(languageSelectOptions)}
                getChange={(e: any) => setLang(e)}
              />
            </>
          }
        />

        <CardLoading loading={loading}>
          <ChartsBox
            data={keywordTimeLineMemo}
            loading={keywordTimelineLoading}
            lang={lang}
            filter={filter}
            dataType="keyword"
          ></ChartsBox>
          <DetailPageTable
            hasNews={true}
            gameInfo={gameInfo}
            channelType={channelType}
            setChannelType={setChannelType}
            defaultPageInfo={{ page: 1, page_size: 5 }}
            filter={filter}
            hasPageable={false}
            wholeGameInfo={wholeGameInfo}
          ></DetailPageTable>
        </CardLoading>
      </ContentBody>
    </Content>
  );
}

export default connect((state: any) => {
  const { loading, opinionCommon, opinionPerformance } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,

    keywordTimeline: opinionPerformance.keywordTimeline,
    keywordTimelineLoading:
      loading.effects['opinionPerformance/getOverviewKeywordTimeline'],
  };
})(Keyword);
